import { Link, useLocation } from 'react-router-dom';
import gooderaWordmark from '@/assets/goodera-wordmark.png';
import basecampLogo from '@/assets/basecamp-logo.png';

const Header = () => {
  const location = useLocation();

  const navLinks = [
    { label: 'Session', to: '/session/1' },
    { label: 'Exchange', to: '/exchange' },
    { label: 'Mentors', to: '/mentors' },
    { label: 'Stack', to: '/stack' },
    { label: 'Interest', to: '/interest' },
  ];

  return (
    <header
      data-testid="global-header"
      className="sticky top-0 z-50 bg-cream border-b border-black/[0.06]"
    >
      <div className="max-w-6xl mx-auto px-6 h-14 flex items-center justify-between">
        {/* Brand + partner lockup */}
        <div className="flex items-center" data-testid="header-brand-lockup">
          {/* AI LAB. — primary brand, unchanged */}
          <Link
            to="/"
            data-testid="header-logo"
            className="font-logo text-2xl tracking-wide text-ink uppercase leading-none select-none"
            style={{ fontFamily: 'Anton, sans-serif', letterSpacing: '0.04em' }}
          >
            AI LAB<span className="text-brand-orange">.</span>
          </Link>

          {/* Partner lockup — hidden on mobile */}
          <div className="hidden md:flex items-center" data-testid="header-partners">
            <span className="mx-4 lg:mx-5 w-px h-5 bg-black/15" aria-hidden="true" />
            <span className="text-[11px] uppercase tracking-[0.1em] text-ink-muted">
              in partnership with
            </span>
            <img
              src={gooderaWordmark}
              alt="Goodera"
              className="ml-3 h-[22px] w-auto object-contain select-none"
            />
            <img
              src={basecampLogo}
              alt="Basecamp"
              className="ml-4 h-[18px] w-auto object-contain select-none"
            />
          </div>
        </div>

        {/* Nav links */}
        <nav className="flex items-center" data-testid="header-nav">
          {navLinks.map((link, i) => (
            <span key={link.to} className="flex items-center">
              {i > 0 && (
                <span className="mx-3 text-ink-muted text-sm select-none">·</span>
              )}
              <Link
                to={link.to}
                data-testid={`header-nav-${link.label.toLowerCase()}`}
                className={`text-sm font-medium transition-colors hover:text-ink ${
                  location.pathname.startsWith(link.to.split('/').slice(0, 2).join('/'))
                    ? 'text-ink'
                    : 'text-ink-secondary'
                }`}
              >
                {link.label}
              </Link>
            </span>
          ))}
        </nav>
      </div>
    </header>
  );
};

export default Header;
